import settings from '@api/routes/oab-api/get-appt-flow-settings';
import firstAvailable from '@api/routes/oab-api/get-first-available-resource';
import wellness from '@api/routes/oab-api/get-wellness-options';
import allResource from '@api/routes/oab-api/get-all-resource-slots';
import slotsByResourceID from '@api/routes/oab-api/get-slots-by-resource-id';
import bookDraft from '@api/routes/oab-api/book-draft-appointment';
import getChallenge from '@api/routes/oab-api/get-challenge';
import confirmChallenge from '@api/routes/oab-api/confirm-challenge';
import confirmBook from '@api/routes/oab-api/confirm-book-appointment';
import * as templates from './templates';
import grabber from '../grabber';
import { atcb_init } from 'add-to-calendar-button';
import counter from '@utils/countdown-timer';
import * as createEl from './oab-create-elements';

//import firstdataMock from './mock-fist-ava-response.json';
//import datejsonMock from './mock-date-time-response.json';

var VCA = VCA || {};

//var firstdata = firstdataMock;
//var datejson = datejsonMock;


VCA.bookAppointmentForm = (function ($) {

    var ui = {};

    var todaysDate = formatDate(new Date());
    var currentSelectedDate = todaysDate;
    var loaderWait = 'wait';

    var bookInfo = {
        'hospitalIDValue': '',
        'hospitalName': '',
        'hospitalType': '',
        'hospitalTimezone':'',
        'isVersion2': '',
        'isLoggedIn': '',
        'isNewClient': 'null',
        'isPrimaryHospital': '',
        'petName': 'pet',
        'petSpecies': '',
        'apptTypeId': '',
        'apptTypeText': '',
        'reasonId':'',
        'appointmentReasonDisplayText': '',
        'clientType': '',
        'clientTypeText': '',
        'clientId': '0',
        'nonClientId': '',
        'conditionMessage': '',
        'resourceID': '',
        'settingsIdValue': '',
        'firstAvailableDate': '',
        'appointmentStartDate': '',
        'appointmentEndDate': '',
        'assetBlock': '',
        'assetName': '',
        'assetDefaultUrl':'',
        'petImgURL':'',
        'ServiceIconUrl':'',
        'timeBlock': '',
        'petId': '0',
        'isCareClubMember':'',
        'clientInfo':'',
        'slectedTimeDisplay': '',
        'slectedDateDisplay':'',
        'expirationTime': 10,
        'firstName': '',
        'lastName': '',
        'email': '',
        'phone': '',
        'sendText': 'false',
        'challengeSuccessful':false,
        'challengeSetId': '',
        'addressChallengeId':'',
        'addressChallengeAnswer': '',
        'petNameChallengeId':'',
        'petNameChallengeAnswer':'',
        'draftAppointmentId': '',
        'utm_campaign': '',
        'utm_content': '',
        'utm_medium': '',
        'utm_source': '',
        'utm_term': '',
        'gclid': '',
        'wellnessType':[]
    }




    function cacheUI() {
        ui.$entry = $('section[data-step="entry"]');
        ui.$errorStep = $('section[data-step="error"]');
        ui.$notimeslots = $('section[data-step="notimeslots"]');
        ui.$selectPet = $('section[data-step="select-pet"]');
        ui.$selectExistPet = $('section[data-step="select-exist-pet"]');
        ui.$apptType = $('section[data-step="appt-reason"]');
        ui.$verifyStep = $('section[data-step="verify-step"]');
        ui.$noFoundUser = $('section[data-step="no-found-user"]');
        ui.$incorrect = $('section[data-step="incorrect-answers"]');
        ui.$apptReason = $('section[data-step="appt-issue"]');
        ui.$confirmAnony = $('section[data-step="confirm-anony"]');
        ui.$wellness = $('section[data-step="well-service"]');
        ui.$wellnessResaon = $('section[data-step="wellness-issue"]');
        ui.$confirmation = $('section[data-step="book-confirm"]');
        ui.$progressBar = $('div[data-progress="bar"]');
        ui.$sections = $('.js-seciton-step');
        ui.$backBtn = $('button[data-btn="back"]');
        ui.$abandonLink = $('.js-abandon-link');
        ui.$loginLink = $('.js-login-link');
        ui.loader = $('.js-loader');
        ui.timeloader = $('.js-time-loader');
        ui.firstAvaItem = $('.fst-ava__item');
        ui.dateList = $('.js-date-list');
        ui.vetSlotList = $('.js-vet-slot-list');

        ui.confirmationBtn = $('.js-client-info-form');
    }

    function init() {
        if ($('.oab__wrapper').length <= 0) {
            return;
        }

        cacheUI();
        initOABForm();

        bindSelectPetClick();
        bindSeclectExistPetClick();
        bindSeclectPetContinueClick();
        bindOtherPetClick();
        bindSeclectConditionClick();
        bindclientTypeClick();
        bindAddNewPetBtnClick();
        bindTypeStepClick();
        bindReasonStepClick();
        bindReasonModalClick();
        bindBackBtnClick();
        bindWellnessBtnClick();
        bindScrollLoadClick();
        bindSeeMoreTimesClick();
        bindBookTimeBtnClick();
        bindClientInfoFormClick();
        bindWellnessContinueClick();
        bindVerifyUserClick();
        bindBookNewClientClick();
        changeDateClick();

        closeListbox();

        // on change
        bindfieldUpdate();
        bindDateChange();

        abandonDataLayerPush();
        showLoader();
    }


    async function initOABForm() {

        bookInfo.hospitalIDValue = ui.$entry.attr('data-attr-hospId');
        bookInfo.hospitalName = ui.$entry.attr('data-attr-hospName');
        bookInfo.hospitalType = ui.$entry.attr('data-attr-hospType');
        bookInfo.settingsIdValue = ui.$entry.attr('data-attr-dsid');


        if(window.location.href.match(/\?./)){
            const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));

            for(const [ key, value ] of urlParams.entries()){
                bookInfo[key] = value;

                if(key == 'returnUrl'){
                    ui.$abandonLink.attr("href", value);
                }
            }
        }


        var params = {hospitalId:bookInfo.hospitalIDValue,settingsId:bookInfo.settingsIdValue};

        const { success, data, error }  = await settings.query(params);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(error);
            hideLoader();
            return;
        }
        let response = data

        bookInfo.isVersion2 = response.IsDigitalApptEnabled;
        bookInfo.isLoggedIn = response.IsLoggedIn;
        bookInfo.isPrimaryHospital = response.IsPrimaryHospital;
        bookInfo.ServiceIconUrl = response.ServicesIconUrl;
        bookInfo.assetDefaultUrl = response.DefaultResourcePhoto;
        bookInfo.hospitalTimezone = response.HospitalTimezone;
        let petTypes = response.PetSpeciesOptions;
        let petApptType = response.AppointmentTypeOptions;
        let petApptReason = response.AppointmentReasonOptions;
        let clientTypes = response.ClientTypeOptions;

       // console.log(response);

        if(bookInfo.isLoggedIn){
            let existPet = response.Client.Pets;
            bookInfo.clientInfo = response.Client;
            bookInfo.clientId = response.Client.ClientId;
            ui.$loginLink.addClass('hidden');

            //create existing pet buttons
            let existPetBody = ui.$selectExistPet.find( ".oab__form__body" );
            createEl.createExistPetBtns(existPet, existPetBody);
        }

        //  createClientTypeBtns(clientTypes);
        let entrytBody = ui.$entry.find( ".oab__form__body" );
        createEl.createClientTypeBtns(clientTypes, entrytBody);

        //createPetTypeBtns(petTypes);
        let petTypetBody = ui.$selectPet.find( ".oab__form__body" );
        let othersList = ui.$selectPet.find( ".js-vca-dropdown-list" );
        createEl.createPetTypeBtns(petTypes, petTypetBody, othersList);

        //createApptTypeBtns(petApptType);
        let apptTypetBody = ui.$apptType.find( ".oab__form__body" );
        createEl.createApptTypeBtns(petApptType, apptTypetBody);

        // createApptReasonBtns(petApptReason);
        let reasonTypetBody = ui.$apptReason.find( ".oab__form__body" );
        createEl.createApptReasonBtns(petApptReason, reasonTypetBody);

        let isRecommendService = (bookInfo.serviceId && bookInfo.serviceId != '') || (bookInfo.serviceName && bookInfo.serviceName != '');
        //console.log('isRecommendService', isRecommendService);
        if(bookInfo.petId != '0' && bookInfo.apptTypeId != '' && bookInfo.reasonId != '' && isRecommendService){
            let getPetUrl = response.Client.Pets.filter(function(pet){
                return pet.Id == bookInfo.petId;
            });
            let getReasonDisplayName = petApptReason.filter(function(reason){
                return reason.Id == bookInfo.reasonId;
            });
            bookInfo.petImgURL = getPetUrl[0].PetPhoto;
            bookInfo.petName = getPetUrl[0].Name;
            bookInfo.appointmentReasonDisplayText = getReasonDisplayName[0].DisplayName;
            ui.$progressBar.show();

            if(bookInfo.serviceId && bookInfo.serviceId != ''){
                updateProgresBar('wellness-issue');
                createWellnessSection(true, false);
            }else if(bookInfo.serviceName && bookInfo.serviceName != ''){
                var targetValue = 'wellness-issue';
                $('section[data-step="' + targetValue + '"').find('.js-conditionmessage').val(bookInfo.serviceName);
                $('section[data-step="' + targetValue + '"').find('.js-conditionmessage').trigger('keyup');
                $('section[data-step="' + targetValue + '"').find('.js-select-btn-condition').removeClass('disabled');
                createWellnessSection(false, true);
            }
        }
        else if (bookInfo.isVersion2) {
            ui.$entry.show();
        }
        else if(bookInfo.isLoggedIn){
            ui.$selectExistPet.show();
            ui.$selectExistPet.find('button[data-btn="back"]').hide();
            ui.$progressBar.show();
            updateProgresBar('select-exist-pet');
        }
        else{
            ui.$selectPet.show();
            ui.$selectPet.find('button[data-btn="back"]').hide();
            ui.$progressBar.show();
            updateProgresBar('select-pet');
        }

        hideLoader();

        window.VCA.oabDatalayer.datalayerPushPageLoad(bookInfo);
    };


    function initdateTimeApptTabs() {
        initFirstAvailable();
        setUpTabListener();
    };

    function setUpTabListener(){
        $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
           if(!$.trim( ui.dateList.html() ).length) {
            initdateDateTimeApptTab();
           }
           else{
            return;
           }
          });
    }

    function changeDateClick() {
        $('.js-seciton-step').on('click', '.js-update-date', function (e) {
            $('.js-fisrt-tab-btn').trigger('click');
            ui.dateList.empty();
            ui.vetSlotList.empty();
            ui.firstAvaItem.find('.asset-block').remove();
            updateSeciton('appt-time');
            initFirstAvailable();
            updateProgresBar('appt-time');
        });
    }


    async function initFirstAvailable() {
        showTimeLoader();


        var params = {hospitalId:bookInfo.hospitalIDValue,IsV2:bookInfo.isVersion2,ReasonId:bookInfo.reasonId,startDate:todaysDate,AppointmentTypeId:bookInfo.apptTypeId,IsNewClient:bookInfo.isNewClient};

        const { success, data, error }  = await firstAvailable.query(params);
        console.log('data', data);
        if(data == null || Object.keys(data).length === 0){
            ui.$sections.hide();
            updateSeciton('notimeslots');
            hideTimeLoader();
		    return;
        }

        if(!success){
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(error);
            hideTimeLoader();
		    return;
        }

       

        let firstdata = data;

        updateFirstAvailableSlot(hideTimeLoader, firstdata);
    }

    function updateFirstAvailableSlot(callback, firstdata) {
        let assetUrl = firstdata.PhotoURI;
        if(firstdata.PhotoURI == null) {
            assetUrl = bookInfo.assetDefaultUrl;
        }
        let credentials = firstdata.ResourceCreds;
        if(firstdata.ResourceCreds == null) {
            credentials = '';
        }
        bookInfo.firstAvailableDate = firstdata.TimeSlots[0].Start;
        currentSelectedDate = bookInfo.firstAvailableDate
        //console.log('first day', bookInfo.firstAvailableDate);

        var firstAvaSlot = `${templates.assetBlock({ displayName:firstdata.ResourceName, ResourceCreds:credentials, imgURL:assetUrl, resourceId:firstdata.ResourceId })}`;
        ui.firstAvaItem.prepend(firstAvaSlot);
        var newDate = displayDate(firstdata.TimeSlots[0].Start);
        var tz = bookInfo.hospitalTimezone;
        var newtTime = new Date(firstdata.TimeSlots[0].Start).toLocaleString('en-us', { hour: 'numeric', minute: 'numeric', timeZone: bookInfo.hospitalTimezone});
        $('.js-fstava-date').text(newDate);
        $('.js-fstava-time').html(newtTime);
        $('.js-select-appt').attr('data-start-time', firstdata.TimeSlots[0].Start).attr('data-end-time', firstdata.TimeSlots[0].End).attr('data-resource-id', firstdata.ResourceId).attr('data-time-display',newtTime).attr('data-date-display', newDate);

        callback();
    }

    function initdateDateTimeApptTab() {
        let initVetTabValue = true;
        updateDateTimeTab(formatDate(bookInfo.firstAvailableDate), initVetTabValue);

        setTimeout(function () {
            $('#bdatepicker').flatpickr({
                inline: true,
                minDate: bookInfo.firstAvailableDate,
                defaultDate: bookInfo.firstAvailableDate,
                dateFormat: "Y-m-d"
            });

            
            //console.log('created calendar');
        }, 100);

        setTimeout(function () {
            $('.flatpickr-prev-month').attr('role', 'button').attr('tabindex', '0');
            $('.flatpickr-next-month').attr('role', 'button').attr('tabindex', '0');
            $('.flatpickr-day.today').attr('tabindex', '0');
          //  console.log('make calendar ADA');
        }, 1000);


    }

    async function initVeterinarianTab(resourcesItem, startDate) {

       let vetResourcesItem = resourcesItem

       //console.log(vetResourcesItem);


       $.each(vetResourcesItem, function (i, resource)  {
        var vetResourceContainer = $(document.createElement('div')).addClass('vet-selector__item js-vet-appts').attr('id', resource.ResourceId);
        var vetTimesContainer = $(document.createElement('div')).addClass('v-asset-times js-grabber js-v-asset-times');
        let vetTimeList ='';
        let vetnoMatches = 0;

        let firstDateFixed = startDate.replace(/-/g, '\/').replace(/T.+/, '');
        let credentials = resource.ResourceCreds;
        if(resource.ResourceCreds == null) {
            credentials = '';
        }
        let assetUrl = resource.PhotoURI;
        if(resource.PhotoURI == null) {
            assetUrl = bookInfo.assetDefaultUrl;
        }

        var assetInfo = `${templates.assetBlock({ displayName:resource.ResourceName, ResourceCreds:credentials, imgURL:assetUrl, resourceId:resource.ResourceId })}`;
        vetResourceContainer.append(assetInfo);

        let secondGroupDate = new Date(addDays(firstDateFixed, 1)).toISOString().slice(0, 10);
        let thirdGroupDate = new Date(addDays(firstDateFixed, 2)).toISOString().slice(0, 10);
        let nextGroupDate = new Date(addDays(firstDateFixed, 3)).toISOString().slice(0, 10);
        let firstGroupDateDisplay = new Date(firstDateFixed).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        let secondGroupDateDisplay = new Date(addDays(firstDateFixed, 1)).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        let thirdGroupDateDisplay = new Date(addDays(firstDateFixed, 2)).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });

        $.each(resource.TimeSlots, function (i, slotTime) {

            let slotDate = formatDate(slotTime.Start);
            if(startDate == slotDate) {
                vetnoMatches += 1;
                var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                var dateDisplay = displayDate(slotTime.Start);
                vetTimeList += `${templates.timeBtn({ displayTime:displayName, resourceId:resource.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate:dateDisplay  })}`;
            }
        });

        if(vetnoMatches < 1) {
            vetTimeList = '<span class="no-match-text">No available appointments</span>'
        }
        let vetItemAsset = `${templates.vetTimeAssets({ displayDate:firstGroupDateDisplay, content:vetTimeList })}`;
        vetTimesContainer.append(vetItemAsset);
        vetResourceContainer.append(vetTimesContainer);

        vetTimeList ='';
        vetnoMatches = 0;
        $.each(resource.TimeSlots, function (i, slotTime) {

            let slotDate = formatDate(slotTime.Start);
            if(secondGroupDate == slotDate) {
                vetnoMatches += 1;
                var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                var dateDisplay = displayDate(slotTime.Start);
                vetTimeList += `${templates.timeBtn({ displayTime:displayName, resourceId:resource.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate:dateDisplay  })}`;
            }
        });

        if(vetnoMatches < 1) {
            vetTimeList = '<span class="no-match-text">No available appointments</span>'
        }
        let vetItemAssetTwo = `${templates.vetTimeAssets({ displayDate:secondGroupDateDisplay, content:vetTimeList })}`;
        vetTimesContainer.append(vetItemAssetTwo);
        vetResourceContainer.append(vetTimesContainer);

        
        vetTimeList ='';
        vetnoMatches = 0;
        $.each(resource.TimeSlots, function (i, slotTime) {

            let slotDate = formatDate(slotTime.Start);
            if(thirdGroupDate == slotDate) {
                vetnoMatches += 1;
                var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                var dateDisplay = displayDate(slotTime.Start);
                vetTimeList += `${templates.timeBtn({ displayTime:displayName, resourceId:resource.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate: dateDisplay })}`;
            }
        });

        if(vetnoMatches < 1) {
            vetTimeList = '<span class="no-match-text">No available appointments</span>'
        }
  //  console.log(vetTimeList);
        let vetItemAssetThree = `${templates.vetTimeAssets({ displayDate:thirdGroupDateDisplay, content:vetTimeList })}`;
        vetTimesContainer.append(vetItemAssetThree);
        vetResourceContainer.append(vetTimesContainer);


        let scrollMoreBtn = '<button data-next-start-date="' + nextGroupDate + '" data-resource-id="' + resource.ResourceId + '" class="v-asset-times__arrow js-scroll-more-times"><span class="sr-only">scroll arrow</span><i class="fas fa-arrow-right"></i></button>'
        vetResourceContainer.append(scrollMoreBtn);
        ui.vetSlotList.append(vetResourceContainer);

        grabber.grabber();


       });


    }

    async function updateDateTimeTab(startDate, initVetTab) {

        showTimeLoader();
        let date = new Date(startDate.replace(/-/g, '\/').replace(/T.+/, ''));
        let month = date.toLocaleString('default', { month: 'short' });
        let day = date.toLocaleString('default', { day: 'numeric' });
        let dayOfWeek = date.toLocaleString('default', { weekday: 'short' });
        let displayDateText = displayDate(startDate);
        $('.js-date-time-calendar-labal').text(displayDateText);
        $('.js-date-time-month-labal').text(month);
        $('.js-date-time-date-labal').text(day);
        $('.js-date-time-day-labal').text(dayOfWeek);
        

        var params = {hospitalId:bookInfo.hospitalIDValue,IsV2:bookInfo.isVersion2,ReasonId:bookInfo.reasonId,startDate:startDate,AppointmentTypeId:bookInfo.apptTypeId,IsNewClient:bookInfo.isNewClient};

        const { success, data, error }  = await allResource.query(params);

        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(error);
            hideLoader();
        }
        let resourcesItem = data;


        resourcesItem.sort(function compare(a, b) {
            var dateA = '';
            var dateB = '';
            if (Object.keys(a.TimeSlots).length > 0) {
                dateA = new Date(a.TimeSlots[0].Start);
            }
            if (Object.keys(b.TimeSlots).length > 0) {
            dateB = new Date(b.TimeSlots[0].Start);
        }
        var nameA = a.ResourceName;
        var nameB = b.ResourceName;
        var dataAEmpty = dateA == '';
        var dataBEmpty = dateB == '';
        if ((!dataAEmpty && (dateA < dateB)) || dataBEmpty) {
            return -1;
        } else if ((!dataBEmpty && (dateA > dateB)) || dataAEmpty) {
            return 1;
        } else {
            if (nameA < nameB) {
                return -1;
            } else if (nameA > nameB) {
                return 1;
            } else {
                return 0;
            }
        }
        });

        //console.log(resourcesItem);

        ui.dateList.empty();

        //console.log('all response', resourcesItem);
        //console.log('start date', startDate);
        var notimesContainer = $(document.createElement('div')).addClass('asset-no-times');



        $.each(resourcesItem, function (i, resource) {

            var resourceContainer = $(document.createElement('div')).addClass('asset-ava');
            var timesContainer = $(document.createElement('div')).addClass('asset-times');
            let timeList ='';
            let matchCount = 0;
            let noMatches = true;
            let credentials = resource.ResourceCreds;
            if(resource.ResourceCreds == null) {
                credentials = '';
            }
            let assetUrl = resource.PhotoURI;
            if(resource.PhotoURI == null) {
                assetUrl = bookInfo.assetDefaultUrl;
            }

            var assetInfo = `${templates.assetBlock({ displayName:resource.ResourceName, ResourceCreds:credentials, imgURL:assetUrl, resourceId:resource.ResourceId })}`;
            resourceContainer.append(assetInfo);

            $.each(resource.TimeSlots, function (i, slotTime) {

                let slotDate = formatDate(slotTime.Start);

              //  console.log('startDate', startDate);
              //  console.log('slotDate', slotDate);

                if(startDate == slotDate) {
                    noMatches = false;
                    matchCount += 1;
                  //  console.log('count', matchCount);

                    var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                    var dateDisplay = displayDate(slotTime.Start);
                    timeList += `${templates.timeBtn({ displayTime:displayName, resourceId:resource.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate: dateDisplay })}`;
                }
            });

            if(noMatches) {
                timeList = $(document.createElement('div')).addClass('js-no-matches no-matches-text').text('There are no times available on this date.');
                timesContainer.append(timeList);
                resourceContainer.append(timesContainer);
                notimesContainer.append(resourceContainer);
            }
            else{
                timesContainer.append(timeList);
                resourceContainer.append(timesContainer);
                if(matchCount > 6) {
                    resourceContainer.append('<a href="#" class="fancy js-show-more-appt-time asset-times__more-btn">See more available times</a>')
                }

                ui.dateList.append(resourceContainer);

            }

        });

        ui.dateList.append(notimesContainer);



        if(initVetTab) {
            initVeterinarianTab(resourcesItem, startDate)
        }

        hideTimeLoader();


    }

    async function updateResourceSlots(startDate, resourceId) {

        showTimeLoader();

     var params = {hospitalId:bookInfo.hospitalIDValue,IsV2:bookInfo.isVersion2,ReasonId:bookInfo.reasonId,startDate:startDate,AppointmentTypeId:bookInfo.apptTypeId,ResourceID:resourceId,IsNewClient:bookInfo.isNewClient};
     const { success, data, error }   = await slotsByResourceID.query(params);

     if(!success){
        console.log('failed', error);
        ui.$sections.hide();
        ui.$errorStep.show();
        $('.js-error-message').text(error);
        hideLoader();
        }
    let vetResourcesItem = data;

     var resourceToUpdate = $('#' + resourceId).find('.js-v-asset-times');;

      
      //  console.log(vetResourcesItem.TimeSlots);


        let vetTimeList ='';
        let vetnoMatches = 0;

        let firstDateFixed = startDate.replace(/-/g, '\/').replace(/T.+/, '');

        let secondGroupDate = new Date(addDays(firstDateFixed, 1)).toISOString().slice(0, 10);
        let thirdGroupDate = new Date(addDays(firstDateFixed, 2)).toISOString().slice(0, 10);
        let nextGroupDate = new Date(addDays(firstDateFixed, 3)).toISOString().slice(0, 10);
        let firstGroupDateDisplay = new Date(firstDateFixed).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        let secondGroupDateDisplay = new Date(addDays(firstDateFixed, 1)).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
        let thirdGroupDateDisplay = new Date(addDays(firstDateFixed, 2)).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });

        $.each(vetResourcesItem.TimeSlots, function (i, slotTime) {

            let slotDate = formatDate(slotTime.Start);
            if(startDate == slotDate) {
                vetnoMatches += 1;
                var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                var dateDisplay = displayDate(slotTime.Start);
                vetTimeList += `${templates.timeBtn({ displayTime:displayName, resourceId:vetResourcesItem.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate:dateDisplay  })}`;
            }
        });

        if(vetnoMatches < 1) {
            vetTimeList = '<span class="no-match-text">No available appointments</span>'
        }
        let vetItemAsset = `${templates.vetTimeAssets({ displayDate:firstGroupDateDisplay, content:vetTimeList })}`;
        resourceToUpdate.append(vetItemAsset);

        vetTimeList ='';
        vetnoMatches = 0;
        $.each(vetResourcesItem.TimeSlots, function (i, slotTime) {

            let slotDate = formatDate(slotTime.Start);
            if(secondGroupDate == slotDate) {
                vetnoMatches += 1;
                var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                var dateDisplay = displayDate(slotTime.Start);
                vetTimeList += `${templates.timeBtn({ displayTime:displayName, resourceId:vetResourcesItem.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate:dateDisplay  })}`;
            }
        });

        if(vetnoMatches < 1) {
            vetTimeList = '<span class="no-match-text">No available appointments</span>'
        }
        let vetItemAssetTwo = `${templates.vetTimeAssets({ displayDate:secondGroupDateDisplay, content:vetTimeList })}`;
        resourceToUpdate.append(vetItemAssetTwo);

        vetTimeList ='';
        vetnoMatches = 0;
        $.each(vetResourcesItem.TimeSlots, function (i, slotTime) {

            let slotDate = formatDate(slotTime.Start);
            if(thirdGroupDate == slotDate) {
                vetnoMatches += 1;
                var displayName = new Date(slotTime.Start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: bookInfo.hospitalTimezone });
                var dateDisplay = displayDate(slotTime.Start);
                vetTimeList += `${templates.timeBtn({ displayTime:displayName, resourceId:vetResourcesItem.ResourceId,startTime:slotTime.Start,endTime:slotTime.End, displayDate:dateDisplay  })}`;
            }
        });

        if(vetnoMatches < 1) {
            vetTimeList = '<span class="no-match-text">No available appointments</span>'
        }
        let vetItemAssetThree = `${templates.vetTimeAssets({ displayDate:thirdGroupDateDisplay, content:vetTimeList })}`;
        resourceToUpdate.append(vetItemAssetThree);

        $('button.js-scroll-more-times[data-resource-id="' + resourceId + '"]').attr('data-next-start-date', nextGroupDate);
        grabber.grabber();

        hideTimeLoader();

    };

    async function createWellnessSection(populateWellness, showNextStep) {

       $('.js-wellness-section-due button').remove();
        $('.js-wellness-section-ava button').remove();

        var params = {hospitalId:bookInfo.hospitalIDValue,clientId:bookInfo.clientId,patientId:bookInfo.petId,reasonId:bookInfo.apptTypeId };

        const { success, data, error }  = await wellness.query(params);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(error);
            hideLoader();
        }
        if (data == '') {
            console.log("no data found");
            var targetValue = 'wellness-issue';
            let backStepValue = 'appt-issue';
            updateSeciton(targetValue);
            updateBackBtn(targetValue, backStepValue);
        }else {
            let wellnessResponse = data;
            let wellnesstBody = ui.$wellness.find( ".oab__form__body" );
            createEl.createWellnessBtns(wellnessResponse, wellnesstBody, bookInfo.isCareClubMember, bookInfo.ServiceIconUrl);
            var targetValue = 'wellness-issue';
            let backStepValue = 'well-service';
            updateBackBtn(targetValue, backStepValue);
            ui.$sections.hide();

            if(showNextStep){
                ui.$wellnessResaon.show();
            }else{
                ui.$wellness.show();
            }
    
            if(populateWellness) {
                let referred =  $('.js-btn-wellness[data-id="' + bookInfo.serviceId + '"]')
                referred.addClass('selected');
                referred.parent().find('.wellness-section__title').after(referred);
            }
            hideLoader();
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue,backStepValue);

        }
    }

    
    async function sendDraftAppointment() {

        let clientID = bookInfo.clientId;
        let patientID = bookInfo.petId;
        if(!bookInfo.isPrimaryHospital && bookInfo.isLoggedIn) {
            clientID = 0;
            patientID = 0;
        }


        var params = {
            hospitalId:bookInfo.hospitalIDValue,
            clientId:clientID,
            patientId:patientID,
            reasonId:bookInfo.reasonId,
            appointmentTypeId:bookInfo.apptTypeId,
            startDate: bookInfo.appointmentStartDate,
            endDate: bookInfo.appointmentEndDate,
            resourceId:bookInfo.resourceID,
            IsV2: bookInfo.isVersion2,
            appointmentNotes: bookInfo.conditionMessage
         };

       // console.log(params);
        const { success, data, error }  = await bookDraft.query(params);
   //     console.log(data);
        if(!success || data.DraftAppointmentId == null ){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(data.GenericServiceErrorMessage);
            hideLoader();
            return;
        }else{
            bookInfo.draftAppointmentId = data.DraftAppointmentId;
            createConfirmStepInfo();
        }
     }

    async function initGetChallenge() {

        var params = {hospitalId:bookInfo.hospitalIDValue,firstName:bookInfo.firstName,lastName:bookInfo.lastName,email:bookInfo.email,phone:bookInfo.phone};
        const { success, data, error }  = await getChallenge.query(params);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            return;
        }
        let response = data
       //  console.log('challenge' , response);
        if (response.Success && response.ChallengeSet != null && response.ChallengeSet.ChallengeResponse != null && response.ChallengeSet.ChallengeResponse.petNameChallenge != null) {
            bookInfo.nonClientId = response.ChallengeSet.ClientId;
            bookInfo.challengeSetId = response.ChallengeSet.ChallengeResponse.id;
            bookInfo.petNameChallengeId = response.ChallengeSet.ChallengeResponse.petNameChallenge.id;


            if(response.ChallengeSet.ChallengeResponse.addressChallenge != null){
                bookInfo.addressChallengeId = response.ChallengeSet.ChallengeResponse.addressChallenge.id;
                let nog = response.ChallengeSet.ChallengeResponse.addressChallenge.gapLength;
                let n = response.ChallengeSet.ChallengeResponse.addressChallenge.gapLength;
                let spaces = new Array(++n).join('*');
                let address = response.ChallengeSet.ChallengeResponse.addressChallenge.preGap + spaces + response.ChallengeSet.ChallengeResponse.addressChallenge.postGap;
                $('.js-verify-address').text(address);
            }else{
                $('.js-verify-address-inputs').hide();
                $('.js-verify-address-inputs input[name="missingAddress"]').val('null')
            }

            //console.log('pet' , response.petNameChallenge.choices);

            let verifyBody = ui.$verifyStep.find(".js-pet-selector-box");
            verifyBody.empty();
            createEl.createVerifyInputs(response.ChallengeSet.ChallengeResponse.petNameChallenge.choices, verifyBody);

            ui.$verifyStep.on('keyup change', 'input', function (e) {
                if ($('.js-verify-address-inputs input[name="missingAddress"]').val().length != '' && $('.js-pet-selector-box input').is(':checked')) {
                    $('.js-verify-user').removeClass('disabled');
                }else{
                    $('.js-verify-user').addClass('disabled');
                }
            });
            ui.$sections.hide();
            ui.$verifyStep.show();
            hideLoader();
            updateProgresBar('verify-step');
        }else{
        /*     ui.$sections.hide();
            ui.$noFoundUser.show();
            hideLoader(); */
            sendBookConfirmation();
        }

    }

    async function checkConfirmChallenge() {
        var params = {
            hospitalId:bookInfo.hospitalIDValue,
            clientId:bookInfo.nonClientId,
            challengeSetId:bookInfo.challengeSetId,
            addressChallengeId:bookInfo.addressChallengeId,
            addressChallengeAnswer:bookInfo.addressChallengeAnswer,
            petNameChallengeId:bookInfo.petNameChallengeId,
            petNameChallengeAnswer:bookInfo.petNameChallengeAnswer
        };

        const { success, data, error }  = await confirmChallenge.query(params);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(error);
            hideLoader();
            return;
        }
        
        let response = data;
        if(!response.Success){
            ui.$sections.hide();
            ui.$noFoundUser.show();
            hideLoader();
        }else if (response.Message == 'Incorrect answers.'){
            ui.$sections.hide();
            ui.$incorrect.show();
            hideLoader();
            bookInfo.clientId = '0';
        }
        else {
            bookInfo.challengeSuccessful = true;
            bookInfo.clientId = response.ChallengeSet.ClientId;
            sendBookConfirmation();
        }
        console.log('data', data);
    }

    async function sendBookConfirmation() {

        let clientID = bookInfo.clientId;
        let patientID = bookInfo.petId;
        if(!bookInfo.isPrimaryHospital && bookInfo.isLoggedIn) {
            if(bookInfo.challengeSuccessful) {
                clientID = bookInfo.nonClientId;
            }else {
                clientID = 0;
            }

            patientID = 0;
        }       

        var params = {
            draftAppointmentId: bookInfo.draftAppointmentId,
            hospitalId:bookInfo.hospitalIDValue,
            clientId:clientID,
            patientId:patientID,
            reasonId:bookInfo.reasonId,
            appointmentTypeId:bookInfo.apptTypeId,
            startDate:bookInfo.appointmentStartDate,
            resourceId:bookInfo.resourceID,
            IsV2:bookInfo.isVersion2,
            firstName: bookInfo.firstName,
            lastName: bookInfo.lastName,
            email: bookInfo.email,
            phone: bookInfo.phone,
            appointmentNotes: bookInfo.conditionMessage,
            isTextOptIn: bookInfo.sendText,
            isPrimaryHospital: bookInfo.isPrimaryHospital,
            ReferrerUrl: document.referrer,
            TrackingUrl: window.location.href,
            TrackingMedium: bookInfo.utmMedium,
            TrackingSource: bookInfo.utmSource,
            TrackingCampaign: bookInfo.utmCampaign,
            TrackingTerm: bookInfo.utmTerm,
            TrackingContent: bookInfo.utmContent,
            GClid: bookInfo.gclid,
            petSpecies: bookInfo.petSpecies,
            petName: bookInfo.petName
        };

     //   console.log(params);
            
        const { success, data, error }  = await confirmBook.query(params);
     //   console.log(data);
        if(!success || data.IsSuccess == false ){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(data.InputErrorMessages);
            hideLoader();
            return;
        }else{
            buildConfirmationPage(data);
        }
    }


    function bindDateChange() {
        $('.js-seciton-step').on('change', '#bdatepicker', function (e) {
            e.preventDefault();
            let date = $(this).val();
            if (date == ''  || date == currentSelectedDate) {
                return;
            }
            currentSelectedDate = date;
            updateDateTimeTab(date);
        });
    }

    function displayDate(date) {
        var display = new Date(date).toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
    
        return display;
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    function formatCalDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [month, day, year ].join('-');
    }

    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    }

    
    function closeListbox() {
        $(document).on( "mouseup touchend", function(e){
            var container = $(".vca-dropdown-select");

            // If the target of the click isn't the container
            if(!container.is(e.target) && container.has(e.target).length === 0){
                let listBox = $('.vca-dropdown-select');
                let listButton = listBox.find('.js-btn-selecter');
                listBox.find('.js-vca-dropdown-list').addClass('hidden');
                listButton.attr("aria-expanded","false");
            }
        });
    }

    
    function updateSeciton(targetValue) {
        ui.$sections.hide();
        $('section[data-step="' + targetValue + '"').show();
        hideLoader();
        updateProgresBar(targetValue);
    }

    function updateProgresBar(targetValue) {
        var progressValue = $('section[data-step="' + targetValue + '"').attr('data-progress');
        if (targetValue === "entry") {
            ui.$progressBar.hide();
        }
        if (targetValue === "select-pet" || targetValue === "select-exist-pet" ) {
            ui.$progressBar.show();
        }
        $('.progress-bar').css('width', progressValue+'%').attr('aria-valuenow', progressValue);
    }

    function updateBackBtn(targetValue, backStepValue) {
        $('section[data-step="' + targetValue + '"]').find('button[data-btn="back"]').attr('data-target', backStepValue);
    }

    function bindBackBtnClick(){
        ui.$backBtn.on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('btn-reset')) {
                $(this).closest('section[data-step]').find('.js-btn-selecter').removeClass('active').show();
                $(this).closest('section[data-step]').find('.js-hidden-step').hide();
                $(this).closest('section[data-step]').find('.js-shelter-link').show();
                $(this).closest('section[data-step]').find('.js-login-link').show();
                $(this).removeClass('btn-reset');
                if($(this).hasClass('remove-on-next')) {
                    $(this).removeClass('remove-on-next');
                    $(this).hide();
                }
                return;
            }
            if ($(this).hasClass('appt-reset')) {
                $('.js-fisrt-tab-btn').trigger('click');
                ui.dateList.empty();
                ui.vetSlotList.empty();
                ui.firstAvaItem.find('.asset-block').remove();
            }

            var targetValue = $(this).attr('data-target');
            updateSeciton(targetValue);
        });
    }

    function bindSeclectExistPetClick() {
        $('.js-seciton-step').on('click', 'button.js-exist-pet-btn', function (e) {
            e.preventDefault();
            var newPetName = $(this).attr('data-pet-name');
            let petNameDisplay = '';
            if (newPetName.length > 37) {
                petNameDisplay = 'your pet';
            }else {
                petNameDisplay = newPetName;
            }
            var targetValue = $(this).attr('data-target');
            bookInfo.petId = $(this).attr('data-pet-id');
            bookInfo.isCareClubMember = $(this).data('careclub');
            bookInfo.petSpecies = $(this).data('species');
            bookInfo.petImgURL = $(this).find('.js-confirm-img').attr('src');
            $('.js-pet-name').each(function() {
                var text = $(this).text();
                $(this).text(text.replace(bookInfo.petName, petNameDisplay));
            })
            bookInfo.petName = newPetName;
            
            let backStepValue = 'select-exist-pet';
            updateBackBtn(targetValue, backStepValue);
            updateSeciton(targetValue);
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue, backStepValue);
        });
    }


    function bindSeclectPetContinueClick() {
        $('.js-select-btn-contiune').on('click', function (e) {
            e.preventDefault();
            let wrap = $(this).closest('.oab__form__body');
            let nameValue = wrap.find('.js-required').val();
            let nameRegex = /^[a-zA-Z-0-9]{1,100}$/;
            //let nameLength = nameValue.replace(/\s/g, '');
            let nameTest = nameRegex.test(nameValue.replace(/\s/g, ''));


            if (!nameTest){
                wrap.find('.js-required').trigger('focus');
                wrap.find('.js-required').addClass('error');
                wrap.find('.input-label-wrapper').addClass('error');
                return;
            }
            else {
                wrap.find('.js-required').removeClass('error');
                wrap.find('.input-label-wrapper').removeClass('error');
            }
            var newPetName = $('#petName').val();
            let petNameDisplay = '';
            if (newPetName.length > 37) {
                petNameDisplay = 'your pet';
            }else {
                petNameDisplay = newPetName;
            }
            $('.js-pet-name').each(function() {
                var text = $(this).text();
                $(this).text(text.replace(bookInfo.petName, petNameDisplay));
            })
            bookInfo.petName = newPetName;
            var targetValue = $(this).attr('data-target');
            let backStepValue = 'select-pet';
            updateBackBtn(targetValue, backStepValue);
            updateSeciton(targetValue);

            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue, backStepValue);
        });
    }

    function bindWellnessContinueClick() {
        $('.js-seciton-step').on('click', 'button.js-wellness-btn-contiune', function (e) {
            e.preventDefault();

            var wellnessTypes = [];
            $('.js-wellness-section .selected').each(function () {
                wellnessTypes.push($(this).attr('data-type-name'));
            });

            wellnessTypes = wellnessTypes.join(', ');
            bookInfo.wellnessType = wellnessTypes;

            var targetValue = $(this).attr('data-target');
            if(bookInfo.serviceName){
                if(wellnessTypes != '') {
                    $('section[data-step="' + targetValue + '"').find('.js-conditionmessage').val(bookInfo.serviceName + ", " + wellnessTypes);
                }else{
                    $('section[data-step="' + targetValue + '"').find('.js-conditionmessage').val(bookInfo.serviceName);
                }
               }else{
                $('section[data-step="' + targetValue + '"').find('.js-conditionmessage').val(wellnessTypes);
               }
            if(wellnessTypes != '') {
                $('section[data-step="' + targetValue + '"').find('.js-conditionmessage').trigger('keyup');
                $('section[data-step="' + targetValue + '"').find('.js-select-btn-condition').removeClass('disabled');

            }
            updateSeciton(targetValue);
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue ,'well-service');
        });
    }

    function bindBookTimeBtnClick() {
        $('.js-seciton-step').on('click', 'button.js-select-appt', function (e) {
            e.preventDefault();
            ui.$sections.hide();

            if(bookInfo.appointmentStartDate === $(this).attr('data-start-time') && bookInfo.resourceID === $(this).attr('data-resource-id')) {
                showLoader();
                createConfirmStepInfo();
            }
            else{
                bookInfo.appointmentStartDate = $(this).attr('data-start-time');
                bookInfo.appointmentEndDate = $(this).attr('data-end-time');
                bookInfo.resourceID = $(this).attr('data-resource-id');
                bookInfo.slectedDateDisplay = $(this).attr('data-date-display');
                bookInfo.slectedTimeDisplay = $(this).attr('data-time-display');
                bookInfo.assetBlock = $('div.asset-block[data-resource-id="' + bookInfo.resourceID + '"]').html();
                bookInfo.assetName = $('div.asset-block[data-resource-id="' + bookInfo.resourceID + '"] div.asset-block__name').text();
                showLoader();
                ui.$sections.hide();
                window.VCA.oabDatalayer.datalayerPushStepSeven(bookInfo,'confirm-anony' , 'appt-time');
                sendDraftAppointment();
            }
        });
    }

    function bindWellnessBtnClick(){
        $('.js-seciton-step').on('click', 'button.js-btn-wellness', function (e) {
            e.preventDefault();
            if($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
            else {
                $(this).addClass('selected');
            }
        });
    }

    function createConfirmStepInfo() {
        let confirmAnonyBody = ui.$confirmAnony.find( ".js-client-asset-block" );
        confirmAnonyBody.empty().append(bookInfo.assetBlock).attr('data-resource-id', bookInfo.resourceID);
        ui.$confirmAnony.find( ".js-selected-date" ).text(bookInfo.slectedDateDisplay);
        ui.$confirmAnony.find( ".js-selected-time" ).text(bookInfo.slectedTimeDisplay);

        if(bookInfo.isLoggedIn) {
            let primaryEmail = '';
            $.each(bookInfo.clientInfo.ClientEmails, function (i, email) {
                if(email.IsPrimary) {
                    primaryEmail =  email.Email;
                }
            });
            let primaryPhone = '';
            $.each(bookInfo.clientInfo.ClientPhones, function (i, phone) {
                if(phone.IsPrimaryContact) {
                    primaryPhone =  phone.PhoneNumber;
                }
            });
            ui.$confirmAnony.find('#fname').val(bookInfo.clientInfo.FirstName);
            ui.$confirmAnony.find('#lname').val(bookInfo.clientInfo.LastName);
            ui.$confirmAnony.find('#email').val(primaryEmail);
            ui.$confirmAnony.find('#phone').val(primaryPhone);
            ui.$confirmAnony.find(".oab__client-info__field-group").hide();
        }
       
        $('section[data-step="confirm-anony"').show();
        $(ui.confirmationBtn).attr('data-time-display', bookInfo.slectedTimeDisplay).attr('data-start-time', bookInfo.timeBlock).attr('data-resource-id', bookInfo.resourceID).attr('data-date-display', bookInfo.slectedDateDisplay);

        hideLoader();
        updateProgresBar('confirm-anony');

        $('.js-appt-countdown').html('<span class="js-counter"></span>');
        let timer = $('.js-counter');

        counter(timer, bookInfo.expirationTime);

    }

   function bindClientInfoFormClick() {
        $('.js-seciton-step').on('click', 'button.js-client-info-form', function (e) {
            e.preventDefault();
            if(!bookInfo.isLoggedIn){
                if(!checkChform()){
                    return;
                }
            }
            if(!bookInfo.isLoggedIn || (bookInfo.isLoggedIn && !bookInfo.isPrimaryHospital)) {
                showLoader();
                initGetChallenge();
            }else{
                showLoader();
                sendBookConfirmation();
            }
            window.VCA.oabDatalayer.datalayerPushBookAppt(bookInfo,'verify-step' ,'confirm-anony' );
        });
    }

 

    function buildConfirmationPage(data) {
        ui.$sections.hide();
        ui.$confirmation.show();
        updateProgresBar('book-confirm');
        let assetw = ui.$confirmation.find('.js-asset-wrapper');
        assetw.empty().append(bookInfo.assetBlock).attr('data-resource-id', bookInfo.resourceID);
        ui.$confirmation.find('.js-confirmation-date').append(bookInfo.slectedDateDisplay);
        ui.$confirmation.find('.js-confirmation-time').text(bookInfo.slectedTimeDisplay);
        ui.$confirmation.find('.js-confirmation-pet-name').text(bookInfo.petName);
        ui.$confirmation.find('.js-confirmation-reason').text(bookInfo.appointmentReasonDisplayText);
        ui.$confirmation.find('.js-confirmation-comment').text(bookInfo.conditionMessage);
        ui.$confirmation.find('.js-confirm-page-img').attr('src',bookInfo.petImgURL);
       // console.log(data);
       // console.log(bookInfo);
        let startTime = new Date(data.Appointment.AppointmentPatients[0].start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false, timeZone: bookInfo.hospitalTimezone });
        let endTime = new Date(data.Appointment.AppointmentPatients[0].end).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false, timeZone: bookInfo.hospitalTimezone });
        let objForCalBtn = {
            "event": {
              "@context":"https://schema.org",
              "@type":"Event",
              "name":"Add to Calendar",
              "description":"Add to Calendar",
                "startDate": formatCalDate(data.Appointment.AppointmentPatients[0].start),
                "endDate": formatCalDate(data.Appointment.AppointmentPatients[0].start),
              "startTime": startTime,
              "endTime": endTime,
              "location":"Location"
            },
            "label":"Add to Calendar",
            "options":[
              "Apple",
              "Google",
              "iCal",
              "Microsoft365",
              "Outlook.com",
              "Yahoo"
            ],
            "timeZone":"currentBrowser",
            "trigger":"click",
            "iCalFileName":"Reminder-Event"
          }
        var script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(objForCalBtn, null,' ');
      //  console.log(obj);
        $('.js-add-to-cal').empty().removeClass('atcb_initialized').hide().addClass('atcb');
        $('.js-add-to-cal').append(script);
        setTimeout(function() {
            atcb_init();
        }, 100);
        
        window.VCA.oabDatalayer.datalayerPushOfferSubmit(bookInfo, 'book-confirm', 'book-confirm');
        hideLoader();
    }

    function checkChform() {
            var mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
            var phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
            var textReg = /^[a-zA-Z -]{2,60}$/;

            let valid = true

            if(!textReg.test($('#fname').val())){
                $('#fname').addClass('error');
                $('#fname').closest('.input-label-wrapper').addClass('error');
                valid = false;
            }else{
                $('#fname').removeClass('error');
                $('#fname').closest('.input-label-wrapper').removeClass('error');
                bookInfo.firstName = $('#fname').val();
            }

            if(!textReg.test($('#lname').val())){
                $('#lname').addClass('error');
                $('#lname').closest('.input-label-wrapper').addClass('error');
                valid = false;
            }else{
                $('#lname').removeClass('error');
                $('#lname').closest('.input-label-wrapper').removeClass('error');
                bookInfo.lastName = $('#lname').val();
            }
            let email = $('#email').val();
            if(!mailFormat.test(email)){
                $('#email').addClass('error');
                $('#email').closest('.input-label-wrapper').addClass('error');
                valid = false;
            }else{
                $('#email').removeClass('error');
                $('#email').closest('.input-label-wrapper').removeClass('error');
                bookInfo.email = $('#email').val();
            }
            let phone = $('#phone').val();
            if(!phoneReg.test(phone)){
                $('#phone').addClass('error');
                $('#phone').closest('.input-label-wrapper').addClass('error');
                valid = false;
            }else{
                $('#phone').removeClass('error');
                $('#phone').closest('.input-label-wrapper').removeClass('error');
                bookInfo.phone = $('#phone').val();
            }if($('#sendText').is(":checked")){
                bookInfo.sendText = true;
            }

            return valid;
    }

    function bindclientTypeClick() {
        $('.js-seciton-step').on('click', 'button[data-btn="client-type"]', function (e) {
            e.preventDefault();

            let clientTypeId = $(this).attr('data-value');
            if (clientTypeId == 0) {
                bookInfo.isNewClient = true;
            } else if (clientTypeId == 1) {
                bookInfo.isNewClient = false;
            }
            bookInfo.clientTypeText =  $(this).text().trim();


            if (bookInfo.isLoggedIn) {
                ui.$sections.hide();
                ui.$selectExistPet.show();
                ui.$selectExistPet.find('button[data-btn="back"]').show();
                updateProgresBar('select-exist-pet');
            } else {
                var targetValue = $(this).attr('data-target');
                var targetValue = $(this).attr('data-target');
                bookInfo.clientType = $(this).attr('data-value');
                updateSeciton(targetValue);
            }
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, 'entry', 'entry');
        });
    }

    function bindAddNewPetBtnClick() {
        $('.js-seciton-step').on('click', 'button.js-add-new-pet', function (e) {
            e.preventDefault();
            var targetValue = $(this).attr('data-target');
            var butonText =  $(this).text().trim();
            bookInfo.petId = '0';
            bookInfo.isCareClubMember = '';
            let backStepValue = 'select-exist-pet';
            updateBackBtn(targetValue, backStepValue);
            updateSeciton(targetValue);
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue, backStepValue);
        });
    }

    function bindSelectPetClick() {
        $('.js-seciton-step').on('click', '.js-show-step', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.oab__form__body');
            wrap.find('.js-show-step').not(this).hide();
            wrap.find('.js-vca-dropdown-button').hide();
            wrap.find('.js-shelter-link').hide();
            wrap.find('.js-login-link').hide();
            bookInfo.petSpecies = $(this).attr('data-type');
            bookInfo.petImgURL = $(this).find('.js-confirm-img').attr('src');
            $(this).addClass('active');
            $(this).closest('section[data-step]').find('button[data-btn="back"]').addClass('btn-reset');
            wrap.find('.js-hidden-step').show();
            if (!bookInfo.isVersion2 && !bookInfo.isLoggedIn) {
                ui.$selectPet.find('button[data-btn="back"]').show().addClass('remove-on-next');
            }
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, 'petName','select-pet');
        });
    }

    function bindOtherPetClick() {
        $('.js-seciton-step').on('click', '.js-other-pet-selecter', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.oab__form__body');
            let listBox = $(this).closest('.vca-dropdown-select');
            let listButton = $(this).closest('.vca-dropdown-select').find('.js-btn-selecter');
            let otherPetName = $(this).attr('data-type');
            bookInfo.petImgURL = listButton.find('.js-confirm-img').attr('src');
            wrap.find('.js-show-step').not(this).hide();
            bookInfo.petSpecies = $(this).attr('data-type');
            listButton.addClass('active');
            $('.js-other-pet-display-name').text(bookInfo.petSpecies);
            listBox.find('.js-vca-dropdown-list').addClass('hidden');
            listButton.attr("aria-expanded","false");
            $(this).closest('section[data-step]').find('button[data-btn="back"]').addClass('btn-reset');
            wrap.find('.js-hidden-step').show();
            if (!bookInfo.isVersion2 && !bookInfo.isLoggedIn) {
                ui.$selectPet.find('button[data-btn="back"]').show().addClass('remove-on-next');
            }
        });
    }

    function bindTypeStepClick() {
        $('.js-seciton-step').on('click', '.js-show-next' , function (e) {
            e.preventDefault();
            var targetValue = $(this).attr('data-target');
            bookInfo.apptTypeId = $(this).attr('data-id');
            bookInfo.apptTypeText = $(this).text().trim();
            $('section[data-step="' + targetValue + '"] div[data-appointmentTypeId').hide();
            $('section[data-step="' + targetValue + '"] div[data-appointmentTypeId="' + bookInfo.apptTypeId + '"').show();
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue, 'appt-reason');
            updateSeciton(targetValue);
        });
    }

    function bindReasonStepClick() {
        $('.js-seciton-step').on('click', '.js-show-textarea', function (e) {
            e.preventDefault();

            bookInfo.reasonId = $(this).attr('data-id');
            bookInfo.appointmentReasonDisplayText = $(this).attr('data-reason');


            if(bookInfo.reasonId==10||bookInfo.reasonId==9||bookInfo.reasonId==8){
                if(bookInfo.petId != '0' && bookInfo.isPrimaryHospital){
                    showLoader();
                    createWellnessSection(false, false);
                }else {
                    var targetValue = 'wellness-issue';
                    let backStepValue = 'appt-issue';
                    updateSeciton(targetValue);
                    updateBackBtn(targetValue, backStepValue);
                    window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue, backStepValue);
                }
            }
            else{
                var wrap = $(this).closest('.oab__form__body');
                wrap.find('.js-show-textarea').not(this).hide();
                $(this).addClass('active');
                $(this).closest('section[data-step]').find('button[data-btn="back"]').addClass('btn-reset');
                wrap.find('.js-hidden-step').show();
            }
        });
    }

    function bindReasonModalClick() {
        $('.js-seciton-step').on('click', '.js-modal-btn', function (e) {
            e.preventDefault();
            $(this).addClass('active');

            $('#appttypemodal-900,#appttypemodal-911').on('hidden.bs.modal', function (e) {
                // do something...
                $('.js-modal-btn').removeClass('active');
              })
        });
    }

    function bindSeclectConditionClick() {
        $('.js-select-btn-condition').on('click', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.oab__form__body');
            if ( wrap.find('.js-required').val() === ''){
                wrap.find('.js-required').trigger('focus');
                return;
            }
            var newMessage = wrap.find('.js-conditionmessage').val();
            bookInfo.conditionMessage = newMessage;
            var targetValue = $(this).attr('data-target');
            let backStepValue = $(this).closest('section[data-step]').attr('data-step');
            updateBackBtn(targetValue, backStepValue);
            updateSeciton(targetValue);
            initdateTimeApptTabs();

            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, targetValue, backStepValue);

        });
    }

    function bindfieldUpdate() {
        $('.js-required').on('keyup', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.oab__form__body');
            var counter = wrap.find('.js-limit-counter');
            if($(this).val() !== '') {
                wrap.find('.js-btn-required').removeClass('disabled');
            }else if($(this).val() === '') {
                wrap.find('.js-btn-required').addClass('disabled');
            }

            if(this.value.length > 256){
                return false;
            }
            counter.html(256 - this.value.length);
        });
    }

    function bindScrollLoadClick() {
        $('.js-seciton-step').on('click', '.js-scroll-more-times', function (e) {
            e.preventDefault();
            let buttonCliked = $(this)
            buttonCliked.css('pointer-events', 'none');
            var totalWidth = 0;
            var dateWrapper = $(this).closest('.js-vet-appts').find('.js-v-asset-times');
            var startDate = $(this).attr('data-next-start-date');
            var resourceId = $(this).attr('data-resource-id');
            buttonCliked.css('pointer-events', 'none');
            dateWrapper.find('.v-asset-times__item').each(function(){
                totalWidth  += $(this).outerWidth(true);
            });
            var maxWidth = dateWrapper.width();
            var leftPos = dateWrapper.scrollLeft();
            dateWrapper.animate({
                scrollLeft: leftPos + 212
            }, 800, function() {
                buttonCliked.css('pointer-events', 'all');
            });
            if(leftPos + maxWidth  >= totalWidth) {
                updateResourceSlots(startDate, resourceId);
            }
        });
    }

    function bindSeeMoreTimesClick() {
        $('.js-seciton-step').on('click', '.js-show-more-appt-time', function (e) {
            e.preventDefault();
            var avaWrapper = $(this).closest('.asset-ava').find('.asset-times');
            if(avaWrapper.hasClass('open')){
                avaWrapper.removeClass('open');
                $(this).text('See more available times');
            }else {
                avaWrapper.addClass('open');
                $(this).text('See less times');
            }
        });
    }

    function bindVerifyUserClick() {
        $('.js-seciton-step').on('click', '.js-verify-user', function (e) {
            e.preventDefault();

            if ($('.js-verify-address-inputs .js-required').val() != '' && $('.js-pet-selector-box input').is(':checked')){
                bookInfo.addressChallengeAnswer = $("input[name='missingAddress']").val();
                bookInfo.petNameChallengeAnswer = $("input[name='petName']:checked").val();
                showLoader();
                checkConfirmChallenge();
            }
        });
    }

    function bindBookNewClientClick() {
        $('.js-seciton-step').on('click', '.js-book-new-client', function (e) {
            e.preventDefault();
            bookInfo.isNewClient = false;
            showLoader();
            sendBookConfirmation();
            window.VCA.oabDatalayer.datalayerPushStepChange(bookInfo, 'book-confirm', 'no-found-user');
        });
    }

    function abandonDataLayerPush() {
        $('.js-seciton-step').on('click', '.js-abandon-link', function (e) {
            let backStepValue = $(this).closest('section[data-step]').attr('data-step');
            window.VCA.oabDatalayer.datalayerAbandon(bookInfo, backStepValue);
        });
    }


    function showTimeLoader() {
        ui.$sections.css('opacity', '.3').css('pointer-events', 'none');
        ui.timeloader.show();
    }
    function hideTimeLoader() {
        ui.timeloader.hide();
        ui.$sections.css('opacity', '1').css('pointer-events', 'all');
    }
    function showLoader() {
        ui.$sections.css('opacity', '.3').css('pointer-events', 'none');
        ui.loader.show();
    }
    function hideLoader() {
        ui.$sections.css('opacity', '1').css('pointer-events', 'all');
        ui.loader.hide();
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.bookAppointmentForm.init();
});